/**
    * @description      : 
    * @author           : 
    * @group            : 
    * @created          : 17/09/2025 - 11:05:43
    * 
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 17/09/2025
    * - Author          : 
    * - Modification    : 
**/



import React, { useRef, useState, useEffect, useMemo } from "react";
import {
  GoogleMap,
  Polygon,
  Marker,
  Autocomplete,
  useJsApiLoader,
  Polyline,
} from "@react-google-maps/api";
import { useLocation } from "react-router-dom";
import { db } from "../../../firebase";
import { storage } from "../../../firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { updateDoc, doc, getDoc } from "firebase/firestore";
import html2canvas from "html2canvas";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../store";
import {
  setMapCenter,
  setTiltLevel,
  setZoomLevel,
  selectedArea,
  addTiltedPolygon,
  addVerticalPolygon,
  addDetectionPoints,
  addRulerLine,
  updateTiltedPolygon,
  removeRulerLine,
  addExcludeArea,
  removeExcludeArea,
  setTiltedPVIntersection,
  clearAllPolygonsAndDetectionPoints,
  setdetectionPointsHeight,
  setVerticalLowerHeight,
  setVerticalUpperHeight,
  addVerticalSlopeArea,
  setTiltedUpperHeight,
  setTiltedLowerHeight,
  addSlopeArea,
  setTilElevationCheck,
  setTilAzimuthCheck,
  setTilEdgeCheck,
  setVerticalElevationCheck,
  setVerticalAzimuthCheck,
  setTiltedSwap,
  setVerticalSwap,
  setVerticalAzimutyhValue,
  setVeticalAverageElevation,
  settiltedAverageElevation,
  setTiltedAzimutyhValue,
  resetAllProjectData
} from "../../../store/reducers/bmapSlice";
import type { Library } from "@googlemaps/js-api-loader";
import images from "../../../images/index";
// import the icons ---
import { BiSolidMapPin } from "react-icons/bi";
import { PiRuler, PiExcludeSquareDuotone } from "react-icons/pi";
import { IoMdAdd } from "react-icons/io";
import { RxMagnifyingGlass } from "react-icons/rx";
import { Dropdown, DropdownItem, DropdownToggle, Image } from "react-bootstrap";
import TiltedTooltip from "./tooltips/tiltedTooltip";
import VerticalTooltip from "./tooltips/verticalTooltip";
import { toast } from "react-toastify";
import { ClipEffect } from "html2canvas/dist/types/render/effects";
import { BsArrowsVertical } from "react-icons/bs";
import IconWrapper from "../../../utils/IconWrapper";
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

type Point = { x: number; y: number };
interface LatLng {
  lat: number;
  lng: number;
}

const MapPageRender: React.FC = () => {
  const isExcludeRemove = useRef(false);
  const center = useSelector((state: RootState) => state.bmap.center);
  const bmapKey = useSelector((state: RootState) => state.bmap.key);
  const bmapZoom = useSelector((state: RootState) => state.bmap.zoom);
  const bmapTilt = useSelector((state: RootState) => state.bmap.tilt);
  const rulerLine = useSelector((state: RootState) => state.bmap.rulerLines);
  const excludeArea = useSelector((state: RootState) => state.bmap.excludeArea);
  const intersectionRef = useRef(false);
  const [initialMousePosition, setInitialMousePosition] = useState<
    any | null
  >();
  const { t } = useTranslation(['mapPage', 'common']);
  const [verticalDataLoaded, setVerticalDataLoaded] = useState<boolean>(false);
  const selectedAreaType = useSelector(
    (state: RootState) => state.bmap.selectedArea?.value
  );
  const tiltedIntersection = useSelector(
    (state: RootState) => state.bmap.tiltedIntersection
  );
  const TiltedPolygon = useSelector(
    (state: RootState) => state.bmap.tiltedPolygons
  );
  const verticalPolygon = useSelector(
    (state: RootState) => state.bmap.verticalPolygons
  );
  const detectionPoints = useSelector(
    (state: RootState) => state.bmap.detectionPoints
  );
  const dispatch = useDispatch();
  const location = useLocation();
  const centerRef = useRef(center);
  const zoomRef = useRef(bmapZoom);
  const tiltRef = useRef(bmapTilt);
  const mapRef = useRef<google.maps.Map | null>(null);
  const [clickedCoords, setClickedCoords] = useState<
    { lat: number; lng: number }[]
  >([]);
  const [ClickedRulerPoints, setClickedRulerPoints] = useState<
    { lat: number; lng: number }[]
  >([]);
  const [clickedTiltedCoords, setClickedTiltedCoords] = useState<
    { lat: number; lng: number }[]
  >([]);
  const [coordinatesArray, setCoordinatesArray] = useState<LatLng[][]>([[]]);
  const [userInput, setUserInput] = useState("");
  const [showRotation, setShowRotation] = useState<number | null>();
  const [dragUpperEdge, setDragUpperEdge] = useState<boolean>(true);
  const [hoveredPolygonIndex, setHoveredPolygonIndex] = useState<number | null>(null);
  const [hoveredVerticalIndex, setHoveredVerticalIndex] = useState<number | null>(null);
  const [hoveredExcludeIndex, setHoveredExcludeIndex] = useState<number | null>(null);
  const [prevX, setPrevX] = useState(null);

  const { projectId } = useParams<{ projectId: string | any }>();

  let mapOptions = {
    mapTypeControl: false,
    streetViewControl: false,
    panControl: false,
    zoomControl: true,
    disableDefaultUI: true,
    mapTypeId: "hybrid",
    styles: [
      {
        featureType: "poi",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi.park",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi.school",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi.medical",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi.business",
        stylers: [{ visibility: "off" }],
      },
    ],
  };
  const libraries: Library[] = useMemo(
    () => ["drawing", "places", "geometry"],
    []
  );
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey:
      process.env.REACT_APP_GOOGLE_API_KEY ||
      "AIzaSyCTXnohcGL0e0EIUr2v4jpEOOoDMKewEaM",
    libraries: libraries,
  });
  const initialPositionRef = useRef<any>();
  const initialAngleRef = useRef<any>(null);
  const selectedPolygonForRotation = useRef<number>(0);

  const handleMouseDown = (e: any, index: number) => {
    selectedPolygonForRotation.current = index;
    initialPositionRef.current = { x: e.clientX, y: e.clientY };
    initialAngleRef.current = 0;

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
  };

  const captureAndUpload = async (id: string) => {
    const html2canvasConfiguration = {
      useCORS: true,
      backgroundColor: null,
      logging: false,
      imageTimeout: 0,
    };
    const element = document.getElementById("captureMap");
    if (!element) {
      return;
    }
    try {
      const canvas = await html2canvas(element, html2canvasConfiguration);
      localStorage.removeItem("mapImage");
      canvas.toBlob(async (blob) => {
        if (!blob) {
          console.error("Error: Unable to capture canvas or canvas is empty.");
          return;
        }
        const storageRef = ref(storage, `mapScreenshot/${id}`);
        await uploadBytes(storageRef, blob);
        const imageUrl = await getDownloadURL(storageRef);
        const docRef = doc(db, "projects", id);
        await updateDoc(docRef, {
          captureImage: imageUrl,
          mapCenter: centerRef.current,
          mapZoom: zoomRef.current,
          // Make sure to keep all other fields you're updating
        });
        localStorage.setItem("mapImage", imageUrl);
        return imageUrl;
      }, "image/png");
    } catch (error) {
      console.error("Error capturing and uploading image:", error);
    }
  };

  const handleMouseMove = (e: any) => {
    const deltaX = e.clientX - initialPositionRef.current.x;
    const deltaY = e.clientY - initialPositionRef.current.y;
    const angle = Math.atan2(deltaY, deltaX) * (180 / Math.PI);
    const newAngle = angle - initialAngleRef.current;
    initialAngleRef.current = angle;
    const newCoords = rotatePolygon(
      TiltedPolygon[selectedPolygonForRotation.current],
      angle
    );

    dispatch(
      addTiltedPolygon({
        index: selectedPolygonForRotation.current,
        tiltedPolygon: newCoords,
      })
    );
  };
  const handleMouseUp = () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };
  useEffect(() => {
   // Update the getData function in MapPageRender.tsx to handle both data formats with TypeScript fixes

   const getData = async () => {
    dispatch(resetAllProjectData());
    
    dispatch(selectedArea({ value: undefined }));
    dispatch(clearAllPolygonsAndDetectionPoints());

    if (!projectId) {
      console.error("Project ID is missing");
      return;
    }

    try {
      const projectIdString = String(projectId);
      console.log("Accessing document with ID:", projectIdString);

      const docRef = doc(db, "projects", projectIdString);
      const docSnap = await getDoc(docRef);
  
      if (docSnap.exists()) {
        const data = docSnap.data() as {
          tiltedPVAreas?: {[key: string]: any};
          verticalPVAreas?: {[key: string]: any};
          tiltedPolygonAzimuthData?: any[];
          verticalPolygonAzimuthData?: any[];
          tiltedPolygonElevation?: any;
          verticalPolygonElevation?: any;
          tiltedPolygons?: string;
          verticalPVArea?: string;
          [key: string]: any;
        };
    
        // Get map center and zoom from stored data
        if (data.mapCenter) {
          centerRef.current = data.mapCenter;
          dispatch(setMapCenter(data.mapCenter));
        }
    
        // Set zoom level from stored data, or default to 20 if not available
        if (data.mapZoom) {
          zoomRef.current = data.mapZoom;
          dispatch(setZoomLevel(data.mapZoom));
        } else {
          zoomRef.current = 20;
          dispatch(setZoomLevel(20));
        }
    
        // Load tilted and vertical polygons from the new consolidated structure or fall back to old structure
        let tiltedPolygonsData: Array<Array<{lat: number, lng: number}>> = [];
        let verticalPolygonsData: Array<Array<{lat: number, lng: number}>> = [];
    
        // 1. First try to get tilted polygons from the new consolidated structure
        if (data.tiltedPVAreas && typeof data.tiltedPVAreas === 'object') {
          // Sort the areas by index
          const sortedAreas = Object.entries(data.tiltedPVAreas)
            .sort(([keyA, _], [keyB, __]) => {
              const indexA = parseInt(keyA.replace('TPV-', ''));
              const indexB = parseInt(keyB.replace('TPV-', ''));
              return indexA - indexB;
            });
          
          // Extract polygon coordinates
          tiltedPolygonsData = sortedAreas
            .map(([_, areaData]) => areaData.polygon || null)
            .filter((poly): poly is Array<{lat: number, lng: number}> => 
              poly !== null && Array.isArray(poly) && poly.length === 4);
        }
        // 2. Fall back to the old structured format
        else if (data.tiltedPolygonAzimuthData && Array.isArray(data.tiltedPolygonAzimuthData) && data.tiltedPolygonAzimuthData.length > 0) {
          // Extract polygon coordinates from the structured format with proper type handling
          const mappedPolygons = data.tiltedPolygonAzimuthData.map(item => {
            if (!item || !item.polygonData) return null;
    
            const polygonData = item.polygonData;
            if (!polygonData.point1 || !polygonData.point2 || !polygonData.point3 || !polygonData.point4) {
              return null;
            }
    
            return [
              { lat: polygonData.point1.lat, lng: polygonData.point1.lon },
              { lat: polygonData.point2.lat, lng: polygonData.point2.lon },
              { lat: polygonData.point3.lat, lng: polygonData.point3.lon },
              { lat: polygonData.point4.lat, lng: polygonData.point4.lon }
            ];
          });
    
          // Filter out nulls with proper type assertion
          tiltedPolygonsData = mappedPolygons.filter((poly): poly is Array<{lat: number, lng: number}> => 
            poly !== null && Array.isArray(poly) && poly.length === 4);
        }
        // 3. Fall back to stringified format as a last resort
        else if (data.tiltedPolygons) {
          try {
            const parsed = JSON.parse(data.tiltedPolygons || "[]");
            tiltedPolygonsData = Array.isArray(parsed) ? parsed : [];
          } catch (error) {
            console.error("Error parsing tilted polygons data:", error);
            tiltedPolygonsData = [];
          }
        }
    
        // console.log("Raw verticalPVAreas", JSON.stringify(data.verticalPVAreas, null, 2));
        // 1. First try to get vertical polygons from the new consolidated structure
        if (data.verticalPVAreas && typeof data.verticalPVAreas === 'object') {
          // console.log("Processing verticalPVAreas with hybrid format handling");
          
          // Process and extract polygon data
          Object.entries(data.verticalPVAreas).forEach(([areaId, areaData], index) => {
            if (!areaId.startsWith('VPV-')) return;
            
            let polygonPoints: Array<{lat: number, lng: number, type?: string}> | null = null;
            
            // Check if using new format (polygon field)
            if (areaData.polygon && Array.isArray(areaData.polygon) && areaData.polygon.length === 2) {
              // console.log(`Area ${areaId} has new format polygon data`);
              polygonPoints = areaData.polygon.map((point: { lat: any; lng: any; }, i: number) => ({
                lat: point.lat,
                lng: point.lng || (point as any).lon,
                type: i === 0 ? "start" : "end"
              }));
            }
            // Check if using old format embedded in new structure (polygonData field)
            else if (areaData.polygonData && 
                areaData.polygonData.upperEdge && 
                areaData.polygonData.lowerEdge) {
              
              // console.log(`Area ${areaId} has old format polygonData embedded in new structure`);
              
              const upperEdge = areaData.polygonData.upperEdge;
              const lowerEdge = areaData.polygonData.lowerEdge;
              
              polygonPoints = [
                { 
                  lat: upperEdge.lat, 
                  lng: upperEdge.lon || upperEdge.lng,
                  type: "start"
                },
                { 
                  lat: lowerEdge.lat, 
                  lng: lowerEdge.lon || lowerEdge.lng,
                  type: "end"
                }
              ];
            }
            
            if (polygonPoints) {
              // Add the polygon to our array
              verticalPolygonsData.push(polygonPoints);
              
              // DIRECTLY dispatch to Redux with correct type information
              const areaIndex = parseInt(areaId.replace('VPV-', '')) - 1;
              
              // console.log(`Directly adding vertical polygon at index ${areaIndex}:`, polygonPoints);
              
              dispatch(addVerticalPolygon({
                index: areaIndex,
                verticalPolygon: polygonPoints
              }));
            }
          });
          
          // console.log("Extracted vertical polygons:", verticalPolygonsData);
        }
        // 2. Fall back to the old structured format
        else if (data.verticalPolygonAzimuthData && Array.isArray(data.verticalPolygonAzimuthData)) {
          // Extract polygon coordinates with proper type handling
          const mappedPolygons = data.verticalPolygonAzimuthData.map(item => {
            if (!item || !item.polygonData) return null;

            // console.log("polygonData",item.polygonData)

            const polygonData = item.polygonData;
            if (!polygonData.upperEdge || !polygonData.lowerEdge) {
              return null;
            }
    
            return [
              { lat: polygonData.upperEdge.lat, lng: polygonData.upperEdge.lon },
              { lat: polygonData.lowerEdge.lat, lng: polygonData.lowerEdge.lon }
            ];
          });
    
          // Filter out nulls with proper type assertion
          verticalPolygonsData = mappedPolygons.filter((poly): poly is Array<{lat: number, lng: number}> => 
            poly !== null && Array.isArray(poly) && poly.length === 2);
        }
        // 3. Fall back to stringified format as a last resort
        else if (data.verticalPVArea) {
          try {
            const parsed = JSON.parse(data.verticalPVArea || "[]");
            verticalPolygonsData = Array.isArray(parsed) ? parsed : [];
          } catch (error) {
            console.error("Error parsing vertical polygons data:", error);
            verticalPolygonsData = [];
          }
        }
    
        // Calculate the bounding box if no center is specified
        if (!data.mapCenter && (tiltedPolygonsData.length > 0 || verticalPolygonsData.length > 0)) {
          // Extract all points from polygons
          const allPoints: Array<{lat: number, lng: number}> = [];
    
          tiltedPolygonsData.forEach(poly => {
            if (poly && Array.isArray(poly)) {
              poly.forEach(point => {
                if (point && typeof point.lat === 'number' && typeof point.lng === 'number') {
                  allPoints.push(point);
                }
              });
            }
          });
    
          verticalPolygonsData.forEach(poly => {
            if (poly && Array.isArray(poly)) {
              poly.forEach(point => {
                if (point && typeof point.lat === 'number' && typeof point.lng === 'number') {
                  allPoints.push(point);
                }
              });
            }
          });
    
          // Calculate the center of all points
          if (allPoints.length > 0 && google && google.maps) {
            const bounds = new google.maps.LatLngBounds();
            allPoints.forEach((point: {lat: number, lng: number}) => {
              bounds.extend(new google.maps.LatLng(point.lat, point.lng));
            });
    
            const center = bounds.getCenter();
            centerRef.current = { lat: center.lat(), lng: center.lng() };
            dispatch(setMapCenter(centerRef.current));
    
            // We'll fit bounds later when the map loads
            sessionStorage.setItem('fitBounds', 'true');
          }
        }
    
        // Add tilted polygons to Redux state
        if (tiltedPolygonsData.length > 0) {
          tiltedPolygonsData.forEach((value, index) => {
            if (value && Array.isArray(value) && value.length === 4) {
              dispatch(addTiltedPolygon({
                index,
                tiltedPolygon: value
              }));
            }
          });
        }
    
        // Add vertical polygons to Redux state
        if (verticalPolygonsData.length > 0) {
          verticalPolygonsData.forEach((value, index) => {
            if (value && Array.isArray(value) && value.length === 2) {
              dispatch(addVerticalPolygon({
                index,
                verticalPolygon: value
              }));
            }
          });
        }
    
        // Load detection points
        if (data.detectionPoint) {
          try {
            const detectionPoints = JSON.parse(data.detectionPoint || "[]");
            if (Array.isArray(detectionPoints) && detectionPoints.length > 0) {
              detectionPoints.forEach((value: any, index: number) => {
                dispatch(addDetectionPoints({ index, detectionPoints: value }));
                if (data.detectionPointHeight && data.detectionPointHeight[index] !== undefined) {
                  dispatch(
                    setdetectionPointsHeight({
                      index,
                      value: data.detectionPointHeight[index],
                    })
                  );
                }
              });
            }
          } catch (error) {
            console.error("Error parsing detection points:", error);
          }
        }
    
        // HANDLE VERTICAL POLYGON PROPERTIES
    
        // Load vertical properties from the new consolidated structure
        if (data.verticalPVAreas && typeof data.verticalPVAreas === 'object') {
          // console.log("Processing verticalPVAreas with special hybrid format handling");
          
          // Sort the areas by index
          const sortedAreas = Object.entries(data.verticalPVAreas)
            .sort(([keyA, _], [keyB, __]) => {
              const indexA = parseInt(keyA.replace('VPV-', ''));
              const indexB = parseInt(keyB.replace('VPV-', ''));
              return indexA - indexB;
            });
          
          // Process each area with handling for both formats
          verticalPolygonsData = sortedAreas
            .map(([areaId, areaData]) => {
              // console.log(`Processing area ${areaId}:`, areaData);
              
              // Check if using new format (polygon field)
              if (areaData.polygon && Array.isArray(areaData.polygon) && areaData.polygon.length === 2) {
                // console.log(`Area ${areaId} has new format polygon data`);
                return areaData.polygon;
              }
              // console.log("New testing",areaData.polygonData)
              // Check if using old format embedded in new structure (polygonData field)
              if (areaData.polygonData && 
                  areaData.polygonData.upperEdge && 
                  areaData.polygonData.lowerEdge) {
                
                // console.log(`Area ${areaId} has old format polygonData embedded in new structure`);
                
                const upperEdge = areaData.polygonData.upperEdge;
                const lowerEdge = areaData.polygonData.lowerEdge;
                
                return [
                  { 
                    lat: upperEdge.lat, 
                    lng: upperEdge.lon || upperEdge.lng,
                    type: "start"
                  },
                  { 
                    lat: lowerEdge.lat, 
                    lng: lowerEdge.lon || lowerEdge.lng,
                    type: "end"
                  }
                ];
              }
              
              // console.log(`Area ${areaId} has no valid polygon data`);
              return null;
            })
            .filter((poly): poly is Array<{lat: number, lng: number, type?: string}> => 
              poly !== null && Array.isArray(poly) && poly.length === 2);
          
          // console.log("Extracted vertical polygons:", verticalPolygonsData);
        }
        // Fall back to the old data structures for vertical properties
        else {
          // Load vertical heights
          if (data.verticalLowerHeight) {
            // Check if it's an array
            if (Array.isArray(data.verticalLowerHeight)) {
              data.verticalLowerHeight.forEach((value: any, index: number) => {
                if (value !== undefined && value !== null) {
                  dispatch(
                    setVerticalLowerHeight({
                      index,
                      floatValue: value,
                    })
                  );
                }
              });
            } else {
              // It's an object with keys as indices
              Object.entries(data.verticalLowerHeight).forEach(([indexStr, value]) => {
                const index = parseInt(indexStr);
                if (value !== undefined && value !== null) {
                  dispatch(
                    setVerticalLowerHeight({
                      index,
                      floatValue: value,
                    })
                  );
                }
              });
            }
          }
    
          if (data.verticalUpperHeight) {
            // Check if it's an array
            if (Array.isArray(data.verticalUpperHeight)) {
              data.verticalUpperHeight.forEach((value: any, index: number) => {
                if (value !== undefined && value !== null) {
                  dispatch(
                    setVerticalUpperHeight({
                      index,
                      floatValue: value,
                    })
                  );
                }
              });
            } else {
              // It's an object with keys as indices
              Object.entries(data.verticalUpperHeight).forEach(([indexStr, value]) => {
                const index = parseInt(indexStr);
                if (value !== undefined && value !== null && !isNaN(index)) {
                  dispatch(
                    setVerticalUpperHeight({
                      index,
                      floatValue: value,
                    })
                  );
                }
              });
            }
          }
    
          // Load vertical slope
          if (data.verticalSlope) {
            if (Array.isArray(data.verticalSlope)) {
              data.verticalSlope.forEach((value: any, index: number) => {
                if (value !== undefined && value !== null) {
                  dispatch(
                    addVerticalSlopeArea({ index, value })
                  );
                }
              });
            } else if (typeof data.verticalSlope === 'object') {
              Object.entries(data.verticalSlope).forEach(([indexStr, value]: [string, any]) => {
                const index = parseInt(indexStr);
                if (value !== undefined && value !== null && !isNaN(index)) {
                  dispatch(
                    addVerticalSlopeArea({ index, value })
                  );
                }
              });
            }
          }
    
          // Load auto-calculate settings
          if (data.verticalCheckedElevation) {
            if (Array.isArray(data.verticalCheckedElevation)) {
              data.verticalCheckedElevation.forEach((value: boolean, index: number) => {
                dispatch(
                  setVerticalElevationCheck({
                    index,
                    check: value,
                  })
                );
              });
            } else if (typeof data.verticalCheckedElevation === 'object') {
              Object.entries(data.verticalCheckedElevation).forEach(([indexStr, value]: [string, any]) => {
                const index = parseInt(indexStr);
                if (!isNaN(index)) {
                  dispatch(
                    setVerticalElevationCheck({
                      index,
                      check: value,
                    })
                  );
                }
              });
            }
          }
    
          if (data.verticalCheckedAzimuth) {
            if (Array.isArray(data.verticalCheckedAzimuth)) {
              data.verticalCheckedAzimuth.forEach((value: boolean, index: number) => {
                dispatch(
                  setVerticalAzimuthCheck({
                    index,
                    check: value,
                  })
                );
              });
            } else if (typeof data.verticalCheckedAzimuth === 'object') {
              Object.entries(data.verticalCheckedAzimuth).forEach(([indexStr, value]: [string, any]) => {
                const index = parseInt(indexStr);
                if (!isNaN(index)) {
                  dispatch(
                    setVerticalAzimuthCheck({
                      index,
                      check: value,
                    })
                  );
                }
              });
            }
          }
    
          // Load vertical swap flags
          if (data.verticalSwap) {
            if (Array.isArray(data.verticalSwap)) {
              data.verticalSwap.forEach((value: boolean, index: number) => {
                dispatch(
                  setVerticalSwap({ index, checked: value })
                );
              });
            } else if (typeof data.verticalSwap === 'object') {
              Object.entries(data.verticalSwap).forEach(([indexStr, value]: [string, any]) => {
                const index = parseInt(indexStr);
                if (!isNaN(index)) {
                  dispatch(
                    setVerticalSwap({ index, checked: value })
                  );
                }
              });
            }
          }
    
          // Load vertical polygon azimuth data
          if (data.verticalPolygonAzimuthData && Array.isArray(data.verticalPolygonAzimuthData)) {
            data.verticalPolygonAzimuthData.forEach((item: any, index: number) => {
              if (item && item.azimuth !== undefined && item.azimuth !== null) {
                dispatch(
                  setVerticalAzimutyhValue({
                    index,
                    azimuth: Number(item.azimuth).toFixed(1),
                  })
                );
              }
            });
          }
    
          // Handle vertical polygon elevation data from old structure
          if (data.verticalPolygonElevation && typeof data.verticalPolygonElevation === 'object') {
            Object.entries(data.verticalPolygonElevation).forEach(([indexStr, pointData]: [string, any]) => {
              const index = parseInt(indexStr);
              if (isNaN(index)) return;
    
              // If we have elevation data, update elevation in Redux
              if ((pointData.apiValue !== null && pointData.isAutoCalculated) ||
                  (pointData.manualValue !== null && !pointData.isAutoCalculated)) {
    
                // Use API value if auto-calculated, otherwise use manual value
                const elevationValue = pointData.isAutoCalculated
                  ? pointData.apiValue
                  : pointData.manualValue;
    
                if (elevationValue !== null) {
                  dispatch(
                    setVeticalAverageElevation({
                      index,
                      value: elevationValue.toFixed(1),
                    })
                  );
                }
              }
            });
          }
        }
    
        // HANDLE TILTED POLYGON PROPERTIES
    
        // Load tilted properties from the new consolidated structure
        if (data.tiltedPVAreas && typeof data.tiltedPVAreas === 'object') {
          Object.entries(data.tiltedPVAreas).forEach(([areaId, areaData]) => {
            if (!areaId.startsWith('TPV-')) return;
            
            const index = parseInt(areaId.replace('TPV-', '')) - 1;
            if (isNaN(index) || index < 0) return;
            
            // Set heights if available
            if (areaData.heights) {
              if (areaData.heights.upper !== null && areaData.heights.upper !== undefined) {
                dispatch(
                  setTiltedUpperHeight({
                    index,
                    floatValue: areaData.heights.upper.toString(),
                  })
                );
              }
              
              if (areaData.heights.lower !== null && areaData.heights.lower !== undefined) {
                dispatch(
                  setTiltedLowerHeight({
                    index,
                    lowerFloatValue: areaData.heights.lower.toString(),
                  })
                );
              }
            }
            
            // Set slope if available
            if (areaData.slope !== undefined && areaData.slope !== null) {
              // Handle both old format (just number) and new format (object with isAutoCalculated)
              const slopeValue = typeof areaData.slope === 'object' && areaData.slope.value !== undefined
                ? areaData.slope.value
                : (typeof areaData.slope === 'number' ? areaData.slope : null);

              const isAutoCalculated = typeof areaData.slope === 'object' && areaData.slope.isAutoCalculated !== undefined
                ? areaData.slope.isAutoCalculated
                : true; // Default to true for old data

              if (slopeValue !== null && slopeValue !== undefined) {
                dispatch(
                  addSlopeArea({
                    index,
                    value: slopeValue.toString(),
                  })
                );
              }

              // Set the edgeChecked based on isAutoCalculated
              dispatch(
                setTilEdgeCheck({
                  index,
                  check: isAutoCalculated ? "PVangle" : null,
                })
              );
            }
            
            // Set elevation data
            if (areaData.elevation) {
              // Set auto-calculate flag
              const isAutoCalculated = areaData.elevation.isAutoCalculated !== undefined ? 
                areaData.elevation.isAutoCalculated : true;
              
              dispatch(
                setTilElevationCheck({
                  index,
                  check: isAutoCalculated,
                })
              );
              
              // Set elevation value - use the appropriate value based on auto/manual setting
              const elevationValue = isAutoCalculated
                ? areaData.elevation.apiValue
                : (areaData.elevation.manualValue !== null ? areaData.elevation.manualValue : areaData.elevation.apiValue);
              
              if (elevationValue !== null && elevationValue !== undefined) {
                dispatch(
                  settiltedAverageElevation({
                    index,
                    elevation: elevationValue.toFixed(1),
                  })
                );
              }
            }
            
            // Set azimuth data
            if (areaData.azimuth) {
              // Set auto-calculate flag
              const isAutoCalculated = areaData.azimuth.isAutoCalculated !== undefined ? 
                areaData.azimuth.isAutoCalculated : false;
              
              dispatch(
                setTilAzimuthCheck({
                  index,
                  check: isAutoCalculated,
                })
              );
              
              // Set azimuth value
              if (areaData.azimuth.value !== null && areaData.azimuth.value !== undefined) {
                dispatch(
                  setTiltedAzimutyhValue({
                    index,
                    azimuth: areaData.azimuth.value.toString(),
                  })
                );
              }
            }

            // NOTE: edgeChecked is now handled by slope.isAutoCalculated above
            // Removed old edgeChecked loading to prevent overriding slope-based checkbox state

            // Set swapped flag
            if (areaData.swapped !== undefined) {
              dispatch(
                setTiltedSwap({
                  index,
                  checked: !!areaData.swapped,
                })
              );
            }
          });
        }
        // Fall back to the old data structures for tilted properties
        else {
          // Load tilted heights
          if (data.tiltedUpperHeight) {
            if (Array.isArray(data.tiltedUpperHeight)) {
              data.tiltedUpperHeight.forEach((value: any, index: number) => {
                if (value !== undefined && value !== null) {
                  dispatch(
                    setTiltedUpperHeight({
                      index,
                      floatValue: value,
                    })
                  );
                }
              });
            } else if (typeof data.tiltedUpperHeight === 'object') {
              Object.entries(data.tiltedUpperHeight).forEach(([indexStr, value]: [string, any]) => {
                const index = parseInt(indexStr);
                if (!isNaN(index) && value !== undefined && value !== null) {
                  dispatch(
                    setTiltedUpperHeight({
                      index,
                      floatValue: value,
                    })
                  );
                }
              });
            }
          }
    
          if (data.tiltedLowerHeight) {
            if (Array.isArray(data.tiltedLowerHeight)) {
              data.tiltedLowerHeight.forEach((value: any, index: number) => {
                if (value !== undefined && value !== null) {
                  dispatch(
                    setTiltedLowerHeight({
                      index,
                      lowerFloatValue: value,
                    })
                  );
                }
              });
            } else if (typeof data.tiltedLowerHeight === 'object') {
              Object.entries(data.tiltedLowerHeight).forEach(([indexStr, value]: [string, any]) => {
                const index = parseInt(indexStr);
                if (!isNaN(index) && value !== undefined && value !== null) {
                  dispatch(
                    setTiltedLowerHeight({
                      index,
                      lowerFloatValue: value,
                    })
                  );
                }
              });
            }
          }
    
          // Load tilted slope
          if (data.slopeArea) {
            if (Array.isArray(data.slopeArea)) {
              data.slopeArea.forEach((value: any, index: number) => {
                if (value !== undefined && value !== null) {
                  dispatch(addSlopeArea({ index, value }));
                }
              });
            } else if (typeof data.slopeArea === 'object') {
              Object.entries(data.slopeArea).forEach(([indexStr, value]: [string, any]) => {
                const index = parseInt(indexStr);
                if (!isNaN(index) && value !== undefined && value !== null) {
                  dispatch(addSlopeArea({ index, value }));
                }
              });
            }
          }
    
          // Load auto-calculate settings
          if (data.tiltedElevationChecked) {
            if (Array.isArray(data.tiltedElevationChecked)) {
              data.tiltedElevationChecked.forEach((value: boolean, index: number) => {
                if (value !== undefined) {
                  dispatch(
                    setTilElevationCheck({
                      index,
                      check: value,
                    })
                  );
                }
              });
            } else if (typeof data.tiltedElevationChecked === 'object') {
              Object.entries(data.tiltedElevationChecked).forEach(([indexStr, value]: [string, any]) => {
                const index = parseInt(indexStr);
                if (!isNaN(index) && value !== undefined) {
                  dispatch(
                    setTilElevationCheck({
                      index,
                      check: value,
                    })
                  );
                }
              });
            }
          }
    
          if (data.tiltedAzimuthChecked) {
            if (Array.isArray(data.tiltedAzimuthChecked)) {
              data.tiltedAzimuthChecked.forEach((value: boolean, index: number) => {
                if (value !== undefined) {
                  dispatch(
                    setTilAzimuthCheck({
                      index,
                      check: value,
                    })
                  );
                }
              });
            } else if (typeof data.tiltedAzimuthChecked === 'object') {
              Object.entries(data.tiltedAzimuthChecked).forEach(([indexStr, value]: [string, any]) => {
                const index = parseInt(indexStr);
                if (!isNaN(index) && value !== undefined) {
                  dispatch(
                    setTilAzimuthCheck({
                      index,
                      check: value,
                    })
                  );
                }
              });
            }
          }
    
          if (data.tiltedEdgeChecked) {
            if (Array.isArray(data.tiltedEdgeChecked)) {
              data.tiltedEdgeChecked.forEach((value: string, index: number) => {
                if (value !== undefined) {
                  dispatch(
                    setTilEdgeCheck({ index, check: value })
                  );
                }
              });
            } else if (typeof data.tiltedEdgeChecked === 'object') {
              Object.entries(data.tiltedEdgeChecked).forEach(([indexStr, value]: [string, any]) => {
                const index = parseInt(indexStr);
                if (!isNaN(index) && value !== undefined) {
                  dispatch(
                    setTilEdgeCheck({ index, check: value })
                  );
                }
              });
            }
          }
    
          // Load tilted swap flags
          if (data.tiltedSwap) {
            if (Array.isArray(data.tiltedSwap)) {
              data.tiltedSwap.forEach((value: boolean, index: number) => {
                if (value !== undefined) {
                  dispatch(setTiltedSwap({ index, checked: value }));
                }
              });
            } else if (typeof data.tiltedSwap === 'object') {
              Object.entries(data.tiltedSwap).forEach(([indexStr, value]: [string, any]) => {
                const index = parseInt(indexStr);
                if (!isNaN(index) && value !== undefined) {
                  dispatch(setTiltedSwap({ index, checked: value }));
                }
              });
            }
          }
    
          // Load tilted polygon azimuth data
          if (data.tiltedAzimuthValue) {
            if (Array.isArray(data.tiltedAzimuthValue)) {
              data.tiltedAzimuthValue.forEach((value: any, index: number) => {
                if (value !== undefined && value !== null) {
                  dispatch(
                    setTiltedAzimutyhValue({
                      index,
                      azimuth: value.toString(),
                    })
                  );
                }
              });
            } else if (typeof data.tiltedAzimuthValue === 'object') {
              Object.entries(data.tiltedAzimuthValue).forEach(([indexStr, value]: [string, any]) => {
                const index = parseInt(indexStr);
                if (!isNaN(index) && value !== undefined && value !== null) {
                  dispatch(
                    setTiltedAzimutyhValue({
                      index,
                      azimuth: value.toString(),
                    })
                  );
                }
              });
            }
          } else if (data.tiltedPolygonAzimuthData && Array.isArray(data.tiltedPolygonAzimuthData)) {
            data.tiltedPolygonAzimuthData.forEach((item: any, index: number) => {
              if (item && item.azimuth !== undefined && item.azimuth !== null) {
                dispatch(
                  setTiltedAzimutyhValue({
                    index,
                    azimuth: Number(item.azimuth).toFixed(1),
                  })
                );
              }
            });
          }
    
          // Handle tilted polygon elevation data from old structure
          if (data.tiltedPolygonElevation && typeof data.tiltedPolygonElevation === 'object') {
            Object.entries(data.tiltedPolygonElevation).forEach(([indexStr, pointData]: [string, any]) => {
              const index = parseInt(indexStr);
              if (isNaN(index)) return;
    
              // If we have elevation data, update average elevation in Redux
              if ((pointData.apiValue !== null && pointData.isAutoCalculated) ||
                  (pointData.manualValue !== null && !pointData.isAutoCalculated)) {
    
                // Use API value if auto-calculated, otherwise use manual value
                const elevationValue = pointData.isAutoCalculated
                  ? pointData.apiValue
                  : pointData.manualValue;
    
                if (elevationValue !== null) {
                  dispatch(
                    settiltedAverageElevation({
                      index,
                      elevation: elevationValue.toFixed(1),
                    })
                  );
                }
              }
            });
          }
        }
    
        // Load excludeArea data
        if (data.excludeArea) {
          try {
            const excludeData = JSON.parse(data.excludeArea || "[]");
            if (Array.isArray(excludeData) && excludeData.length > 0) {
              excludeData.forEach((value: any, index: number) => {
                setCoordinatesArray((prev) => {
                  const newArray = [...prev];
                  newArray[index] = value;
                  return newArray;
                });
              });
            }
          } catch (error) {
            console.error("Error parsing exclude area data:", error);
          }
        }
    
        // Load ruler line data
        if (data.rulerLine && Array.isArray(data.rulerLine)) {
          data.rulerLine.forEach((value: any, index: number) => {
            if (value && value.start && value.end) {
              const newPolyline = [
                {
                  lat: value.start.lat,
                  lng: value.start.lng,
                  type: "start",
                },
                {
                  lat: value.end.lat,
                  lng: value.end.lng,
                  type: "end",
                },
              ];
              dispatch(addRulerLine({ index, rulerLine: newPolyline }));
            }
          });
        }
      } else {
        console.log("No such document exists!");
      }
    } catch (error) {
      console.error("Error loading project data:", error);
    }
  };
  
  console.log("useEffect running with projectId:", projectId);

  if (projectId) {
    getData();
  }
  }, [projectId, dispatch]);


  useEffect(() => {
    if (verticalDataLoaded && verticalPolygon.length > 0) {
      // console.log("Vertical data loaded, forcing re-render");
      
      // Force re-render with multiple approaches to ensure it works
      dispatch(setMapCenter({...centerRef.current}));
      
      // Additional trigger after a short delay
      setTimeout(() => {
        if (mapRef.current) {
          const currentCenter = mapRef.current.getCenter();
          if (currentCenter) {
            const center = { lat: currentCenter.lat(), lng: currentCenter.lng() };
            dispatch(setMapCenter({...center}));
          }
        }
      }, 500);
      
      // Clear the flag after handling
      setVerticalDataLoaded(false);
    }
  }, [verticalDataLoaded, verticalPolygon.length, dispatch]); 
  
  const handleMapDragEnd = () => {
    if (mapRef.current) {
      const newCenter = mapRef.current.getCenter();
      if (newCenter) {
        centerRef.current = { lat: newCenter.lat(), lng: newCenter.lng() };
        dispatch(setMapCenter(centerRef.current));
      }
    }
  };
  const handleZoomChange = () => {
    if (mapRef.current) {
      const newZoom = mapRef.current.getZoom();
      if (newZoom) {
        zoomRef.current = newZoom;
        dispatch(setZoomLevel(zoomRef.current));
      }
    }
  };
  //this useEffect to ensure vertical polygons are properly rendered

  useEffect(() => {
    if (verticalPolygon.length > 0) {
      // Force a re-render of the component when vertical polygons are loaded
      dispatch(setMapCenter({...centerRef.current}));
    }
  }, [verticalPolygon.length, dispatch]);

  // Improve the map loading function to ensure all elements are properly positioned
  const onMapLoad = (map: google.maps.Map) => {
    mapRef.current = map;
    map.setZoom(zoomRef.current);

    // Check if we need to fit bounds
    if (sessionStorage.getItem('fitBounds') === 'true') {
      sessionStorage.removeItem('fitBounds');

      // Use a small timeout to ensure all polygons are loaded
      setTimeout(() => {
        // Create bounds from all polygons
        if (TiltedPolygon.length > 0 || verticalPolygon.length > 0) {
          const bounds = new google.maps.LatLngBounds();

          // Add tilted polygon points to bounds
          TiltedPolygon.forEach(poly => {
            poly.forEach(point => {
              bounds.extend(new google.maps.LatLng(point.lat, point.lng));
            });
          });

          // Add vertical polygon points to bounds
          verticalPolygon.forEach(poly => {
            poly.forEach(point => {
              bounds.extend(new google.maps.LatLng(point.lat, point.lng));
            });
          });

          // Fit the map to those bounds with some padding
          map.fitBounds(bounds, 50); // 50 pixels of padding

          // After the bounds are set, zoom out slightly for better context
          google.maps.event.addListenerOnce(map, 'bounds_changed', () => {
            const zoom = map.getZoom();
            if (zoom && zoom > 20) {
              map.setZoom(20);
              zoomRef.current = 20;
              dispatch(setZoomLevel(20));
            }
          });
        }
      }, 500); // Short delay to ensure all state is updated
    }
  };
  useEffect(() => {
    const polyLength = TiltedPolygon?.length - 1;
    if (TiltedPolygon[polyLength]?.length == 4) {
      const lengthUpperEdge = calculateLineLength([
        TiltedPolygon[polyLength][0],
        TiltedPolygon[polyLength][1],
      ]);
      if (lengthUpperEdge <= 22.36) {
        setDragUpperEdge(true);
      } else {
        setDragUpperEdge(false);
      }
    }
  }, [TiltedPolygon]);

  const handleTiltChange = () => {
    if (mapRef.current) {
      const newTilt = mapRef.current.getTilt();
      if (newTilt) {
        tiltRef.current = newTilt;
        dispatch(setTiltLevel(newTilt));
      }
    }
  };
  const handleExcludeArea = (newCoords: { lat: number; lng: number }) => {
    if (selectedAreaType === "exclude") {
      const newArray = [...coordinatesArray];
      let currentSubArray = newArray[newArray.length - 1];
      currentSubArray?.push(newCoords);

      if (
        currentSubArray?.length > 1 &&
        currentSubArray[0]?.lat === newCoords.lat &&
        currentSubArray[0]?.lng === newCoords.lng
      ) {
        newArray.push([]);
        dispatch(selectedArea({ value: undefined }));
      }

      setCoordinatesArray(newArray);

      dispatch(
        addExcludeArea({
          index: coordinatesArray.length - 1,
          latlng: newCoords,
        })
      );
      isExcludeRemove.current = true;
    }
  };

  useEffect(() => {
    dispatch(removeExcludeArea());
    coordinatesArray.forEach((value, index) => {
      if (index >= 0) {
        for (let i = 0; i <= value.length - 1; i++) {
          dispatch(
            addExcludeArea({
              index: index,
              latlng: value[i],
            })
          );
        }
      }
    });
  }, [coordinatesArray]);

  useEffect(() => {
    if (excludeArea.length === 0 && isExcludeRemove.current) {
      setCoordinatesArray([[]]);
      isExcludeRemove.current = false;
    }
  }, [excludeArea]);

  const handleMapClick = (event: google.maps.MapMouseEvent) => {
    if (selectedAreaType === "ruler") {
      if (event.latLng) {
        const newCoords = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng(),
        };
        setClickedRulerPoints((prevMarkers) => [...prevMarkers, newCoords]);
      }
    }

    if (selectedAreaType === "vertical") {
      if (verticalPolygon.length <= 4) {
        if (event.latLng) {
          const newCoords = {
            lat: event.latLng.lat(),
            lng: event.latLng.lng(),
          };

          if (clickedCoords.length === 1) {
            const distance =
              google?.maps?.geometry?.spherical.computeDistanceBetween(
                new google.maps.LatLng(
                  clickedCoords[0]?.lat,
                  clickedCoords[0]?.lng
                ),
                new google.maps.LatLng(newCoords.lat, newCoords.lng)
              );
            const maxDistanceThreshold = 200;
            if (distance >= maxDistanceThreshold) {
              toast.error(t('mapPage:errors.lengthThreshold'));
            } else {
              setClickedCoords((prevMarkers) => {
                return [...prevMarkers, newCoords];
              });
            }
          } else {
            setClickedCoords((prevMarkers) => {
              return [...prevMarkers, newCoords];
            });
          }
        }
      } else {
        toast.error(t('mapPage:errors.verticalLimit'));
      }
    }

    if (selectedAreaType === "tilted" && event.latLng) {
      if (intersectionRef.current) {
        return toast.error("Tilted PV area is intersected");
      }
      if (TiltedPolygon.length <= 11) {
        const newCoords = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng(),
        };
        if (
          clickedTiltedCoords.length <= 2 &&
          clickedTiltedCoords.length >= 1
        ) {
          const distance =
            google?.maps?.geometry?.spherical.computeDistanceBetween(
              new google.maps.LatLng(
                clickedTiltedCoords[clickedTiltedCoords.length - 1]?.lat,
                clickedTiltedCoords[clickedTiltedCoords.length - 1]?.lng
              ),
              new google.maps.LatLng(newCoords.lat, newCoords.lng)
            );
          const maxDistanceThreshold = 200;
          if (distance >= maxDistanceThreshold) {
            toast.error(
              t('mapPage:errors.lengthThreshold',)
            );
          } else {
            setClickedTiltedCoords((prevCoords) => [...prevCoords, newCoords]);
          }
        } else {
          setClickedTiltedCoords((prevCoords) => [...prevCoords, newCoords]);
        }
      } else {
        toast.error("Tilted PV area limit exceed");
      }
    }

    if (selectedAreaType === "detection") {
      if (detectionPoints.length <= 9) {
        if (event.latLng) {
          const newCoords = {
            lat: event.latLng.lat(),
            lng: event.latLng.lng(),
          };
          dispatch(
            addDetectionPoints({
              index: detectionPoints.length,
              detectionPoints: [newCoords],
            })
          );
        }
        dispatch(selectedArea({ value: "detectionTab" }));
      } else {
        toast.error("Detection point limit exceed");
      }
    }
    if (selectedAreaType === "exclude") {
      if (event.latLng) {
        const newCoords = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng(),
        };

        handleExcludeArea(newCoords);
      }
      return;
    }
  };

  const calculateLineLength = (
    coord: [{ lat: number; lng: number }, { lat: number; lng: number }]
  ) => {
    const length = google?.maps?.geometry?.spherical.computeDistanceBetween(
      new google.maps.LatLng(coord[0]?.lat, coord[0]?.lng),
      new google.maps.LatLng(coord[1].lat, coord[1].lng)
    );
    return Number(length);
  };

  useEffect(() => {
    if (ClickedRulerPoints.length === 2) {
      const newPolyline = [
        {
          lat: ClickedRulerPoints[0].lat,
          lng: ClickedRulerPoints[0].lng,
          type: "start",
        },
        {
          lat: ClickedRulerPoints[1].lat,
          lng: ClickedRulerPoints[1].lng,
          type: "end",
        },
      ];
      dispatch(
        addRulerLine({ index: rulerLine.length, rulerLine: newPolyline })
      );
      setClickedRulerPoints([]);
      dispatch(selectedArea({ value: undefined }));
    }
  }, [ClickedRulerPoints]);
  useEffect(() => {
    const handleVerticalPVArea = () => {
      if (clickedCoords.length === 2) {
        const newPolyline = [
          { ...clickedCoords[0], type: "start" },
          { ...clickedCoords[1], type: "end" },
        ];
        dispatch(
          addVerticalPolygon({
            index: verticalPolygon.length,
            verticalPolygon: newPolyline,
          })
        );
        setClickedCoords([]);
        dispatch(selectedArea({ value: "verticalTab" }));
      }
    };
    handleVerticalPVArea();
  }, [clickedCoords]);

  useEffect(() => {
    const handleTiltedPVArea = () => {
      const pointsLength = clickedTiltedCoords.length;
      const [p1, p2, p3] = clickedTiltedCoords;

      if (pointsLength === 3) {
        const fourthPoint = {
          lat: p1.lat - (p2.lat - p3.lat),
          lng: p1.lng - (p2.lng - p3.lng),
        };
        setClickedTiltedCoords((prevCoords) => [...prevCoords, fourthPoint]);
      }

      if (pointsLength === 4) {
        const tiltedPolygon = clickedTiltedCoords.map(({ lat, lng }) => ({
          lat,
          lng,
        }));
        dispatch(
          addTiltedPolygon({ index: TiltedPolygon.length, tiltedPolygon })
        );
        setClickedTiltedCoords([]);
        dispatch(selectedArea({ value: "tiltedTab" }));
      }
    };
    handleTiltedPVArea();
  }, [clickedTiltedCoords]);

  const calculateRulerLength = (coords: {
    start: { lat: number; lng: number };
    end: { lat: number; lng: number };
  }) => {
    const length = google?.maps?.geometry?.spherical
      .computeDistanceBetween(
        new google.maps.LatLng(coords.start.lat, coords.start.lng),
        new google.maps.LatLng(coords.end.lat, coords.end.lng)
      )
      ?.toFixed(2);
    return length;
  };
  const handleAreaClick = (areaType: string) => {
    if (loadError) {
      return <div>Error loading Google Maps API</div>;
    }
    dispatch(selectedArea({ value: areaType }));
  };

  useEffect(() => {
    if (
      selectedAreaType === "tilted" ||
      selectedAreaType === "vertical" ||
      selectedAreaType === "ruler" ||
      selectedAreaType === "exclude" ||
      selectedAreaType === "detection"
    ) {
      mapRef.current?.setOptions({ draggableCursor: "crosshair" });
    } else {
      mapRef.current?.setOptions({ draggableCursor: "pointer" });
    }
  }, [selectedAreaType]);

  const autocompleteRef = useRef<any>(null);

  const handlePlaceSelect = () => {
    const autocomplete = autocompleteRef.current;
    if (autocomplete) {
      const place = autocomplete.getPlace();
      if (place?.geometry) {
        const newCenter = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        };
        const addressComponents = place.address_components;
        let city = "";
        for (let component of addressComponents) {
          if (component.types.includes("locality")) {
            city = component.long_name;
            setUserInput(city);
            break;
          }
        }

        // Update center and map
        centerRef.current = newCenter;
        dispatch(setMapCenter(newCenter));
        if (mapRef.current) {
          mapRef.current.panTo(newCenter);
          setTimeout(() => {
            mapRef.current && mapRef.current.setZoom(20); // Set zoom level after a delay
            zoomRef.current = 20;
            dispatch(setZoomLevel(23));
          }, 300); // Adjust delay time as needed
        }
      }
    }
  };
  // check if the polygon overlap
  function checkIfLinesIntersect(
    poly: { lat: number; lng: number }[]
  ): boolean {
    const vertices = poly.map(({ lng, lat }) => ({ x: lng, y: lat }));

    for (let i = 0; i < vertices.length; i++) {
      const line1Start = vertices[i];
      const line1End = vertices[(i + 1) % vertices.length];

      for (let j = i + 1; j < vertices.length; j++) {
        const line2Start = vertices[j];
        const line2End = vertices[(j + 1) % vertices.length];

        if (
          isLineSegmentsIntersect(line1Start, line1End, line2Start, line2End)
        ) {
          intersectionRef.current = true;
          return true;
        }
      }
    }
    intersectionRef.current = false;
    return false;
  }

  function isLineSegmentsIntersect(
    line1Start: Point,
    line1End: Point,
    line2Start: Point,
    line2End: Point
  ): boolean {
    const direction1 = direction(line2Start, line2End, line1Start);
    const direction2 = direction(line2Start, line2End, line1End);
    const direction3 = direction(line1Start, line1End, line2Start);
    const direction4 = direction(line1Start, line1End, line2End);
    return (
      ((direction1 > 0 && direction2 < 0) ||
        (direction1 < 0 && direction2 > 0)) &&
      ((direction3 > 0 && direction4 < 0) || (direction3 < 0 && direction4 > 0))
    );
  }

  function direction(point1: Point, point2: Point, point3: Point): number {
    return (
      (point3.x - point1.x) * (point2.y - point1.y) -
      (point3.y - point1.y) * (point2.x - point1.x)
    );
  }
  const handleChange = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setUserInput(event.target.value);
  };

  const handleEnterPress = async (e: { key: string }) => {
    if (e.key === "Enter") {
      await geocodeAddress(userInput);
    }
  };

  const geocodeAddress = async (address: string) => {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ address }, (results: any, status) => {
      if (status === "OK") {
        const location = results[0].geometry.location;
        // autocompleteRef.current = location;
        const newCenter = {
          lat: location.lat(),
          lng: location.lng(),
        };
        let city = " ";
        const addressComponents = results[0].address_components;
        for (let component of addressComponents) {
          if (component.types.includes("locality")) {
            city = component.long_name;
            setUserInput(city);
            break;
          }
        }
        centerRef.current = newCenter;
        dispatch(setMapCenter(newCenter));
        if (mapRef.current) {
          mapRef.current.panTo(newCenter);
          setTimeout(() => {
            mapRef.current && mapRef.current.setZoom(20);
            zoomRef.current = 20;
            dispatch(setZoomLevel(20));
          }, 300);
        }
      }
    });
  };

  const calculateAdjustedCoords = (
    lat: number,
    lng: number,
    polygonIndex: number,
    index1: number,
    index2: number
  ) => {
    const directionVector = {
      lat: lat - TiltedPolygon[polygonIndex][index1].lat,
      lng: lng - TiltedPolygon[polygonIndex][index1].lng,
    };

    const refVector = {
      lat: TiltedPolygon[polygonIndex][index1].lat -
        TiltedPolygon[polygonIndex][index2].lat,
      lng: TiltedPolygon[polygonIndex][index1].lng -
        TiltedPolygon[polygonIndex][index2].lng,
    };

    const dotProduct =
      directionVector.lat * refVector.lat + directionVector.lng * refVector.lng;
    const refVectorLength = Math.sqrt(
      refVector.lat * refVector.lat + refVector.lng * refVector.lng
    );
    const projectionLength = dotProduct / refVectorLength;

    const projectionVector = {
      lat: projectionLength * (refVector.lat / refVectorLength),
      lng: projectionLength * (refVector.lng / refVectorLength),
    };

    return {
      lat: TiltedPolygon[polygonIndex][index1].lat + projectionVector.lat,
      lng: TiltedPolygon[polygonIndex][index1].lng + projectionVector.lng,
    };
  };

  // React.useImperativeHandle(
  //   ref,
  //   () => ({
  //     captureAndUpload
  //   }),
  //   [captureAndUpload]
  // );

  // Function to calculate the centroid of a polygon
  const calculateCentroid = (polygon: any) => {
    let latSum = 0;
    let lngSum = 0;
    const numPoints = polygon.length;

    polygon.forEach((point: { lat: number; lng: number }) => {
      latSum += point.lat;
      lngSum += point.lng;
    });

    return {
      lat: latSum / numPoints,
      lng: lngSum / numPoints,
    };
  };

  const calculateCentroidofExclude = (coords: any[]) => {
    const centroid = coords.reduce(
      (acc, coord) => {
        acc.lat += coord.lat;
        acc.lng += coord.lng;
        return acc;
      },
      { lat: 0, lng: 0 }
    );

    return {
      lat: centroid.lat / coords.length,
      lng: centroid.lng / coords.length,
    };
  };

  const rotatePolygon = (polygon: any, angle: number) => {
    const centroid = calculateCentroid(polygon);
    const angleRad = (angle * Math.PI) / 180; // Convert angle to radians

    return polygon.map((point: { lat: number; lng: number }) => {
      const latDiff = point.lat - centroid.lat;
      const lngDiff = point.lng - centroid.lng;

      const newLat =
        centroid.lat +
        latDiff * Math.cos(angleRad) -
        lngDiff * Math.sin(angleRad);
      const newLng =
        centroid.lng +
        latDiff * Math.sin(angleRad) +
        lngDiff * Math.cos(angleRad);

      return { lat: newLat, lng: newLng };
    });
  };

// Callback to run when each Marker instance loads

const handleMarkerLoad = (marker:any) => {
  marker.setOptions({
    crossOnDrag: false,
    draggableCursor: "pointer"
  });
};

  return (
    <div className="map-container">
      <TiltedTooltip />
      <VerticalTooltip />
      <section className="map-topBar">
        <Dropdown className="m-0 p-0 rulerDropdown">
          <Dropdown.Toggle
            variant="none"
            style={{ border: "none", margin: "0px", padding: "0px" }}
          >
            <div
              className={`ruler ${
                selectedAreaType === "ruler" ? "selectedMapTab" : ""
              }`}
            >
              <IconWrapper Icon={PiRuler}  size={20} />
            </div>
            <Dropdown.Menu variant="none">
            <Dropdown.Item
    onClick={() => handleAreaClick("ruler")}
    className={selectedAreaType === "ruler" ? "rulerItem" : ""}
  >
    {t('mapPage:mapButtons.addRuler')}
  </Dropdown.Item>

  <Dropdown.Item
    disabled={rulerLine.length > 0 ? false : true}
    onClick={() => {
      dispatch(selectedArea({ value: undefined }));
      dispatch(removeRulerLine());
    }}
  >
    {t('mapPage:mapButtons.removeRuler')}
  </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown.Toggle>
        </Dropdown>

        <Dropdown className="addPVarea">
          <Dropdown.Toggle
            variant="none"
            className="addPVareaToggle"
            id="dropdown-basic"
          >
            <div
    className={`pv-area ${
      selectedAreaType === "tilted" || selectedAreaType === "vertical"
        ? "selectedMapTab"
        : ""
    }`}
  >
    <IconWrapper Icon={IoMdAdd} size={20} /> {t('mapPage:mapButtons.addPVArea')}
  </div>
          </Dropdown.Toggle>
          <Dropdown.Menu variant="none">
          <Dropdown.Item
    className={`addPVareaDropdownItems ${
      selectedAreaType === "tilted"
        ? " addPVareaDropdownItemsActive"
        : ""
    }`}
    onClick={() => handleAreaClick("tilted")}
  >
    <Image src={images.TiltedPVAreaImage} /> {t('mapPage:mapButtons.tiltedPVArea')}
  </Dropdown.Item>
  <Dropdown.Item
    className={`addPVareaDropdownItems ${
      selectedAreaType === "vertical"
        ? " addPVareaDropdownItemsActive"
        : ""
    }`}
    onClick={() => handleAreaClick("vertical")}
  >
    <Image src={images.VerticalPVAreaImage} /> {t('mapPage:mapButtons.verticalPVArea')}
  </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <div
    className={`detection_point ${
      selectedAreaType === "detection" ? "selectedMapTab" : ""
    }`}
    onClick={() => handleAreaClick("detection")}
  >
    <IconWrapper Icon={BiSolidMapPin} size={20} /> {t('mapPage:mapButtons.addDetectionPoint')}
  </div>
        <Dropdown className="excludeDropdown">
          <DropdownToggle variant="none" style={{ border: "none" }}>
          <div
    className={`exclude_area ${
      selectedAreaType === "exclude" ? "selectedMapTab" : ""
    }`}
    color="#fff"
  >
    <IconWrapper Icon={PiExcludeSquareDuotone} size={20} /> {t('mapPage:mapButtons.excludeArea')}
  </div>
          </DropdownToggle>
          <Dropdown.Menu>
          <DropdownItem onClick={() => handleAreaClick("exclude")}>
    {t('mapPage:mapButtons.addExcludeArea')}
  </DropdownItem>

  <DropdownItem
    disabled={excludeArea?.length > 0 ? false : true}
    onClick={() => {
      setCoordinatesArray([[]]);
      dispatch(removeExcludeArea());
    }}
  >
    {t('mapPage:mapButtons.removeExcludeArea')}
  </DropdownItem>
          </Dropdown.Menu>
        </Dropdown>
        {isLoaded && (
          <Autocomplete
            onLoad={(autocomplete) => (autocompleteRef.current = autocomplete)}
            onPlaceChanged={handlePlaceSelect}
            types={["geocode"]}
            fields={["address_components", "geometry", "formatted_address"]}
          >
            <div className="Search_on_map">
            <IconWrapper Icon={RxMagnifyingGlass}  size={20} className="searchAddresssimage"/>
            <input
    className="searchAddresss"
    placeholder={t('mapPage:mapButtons.searchAddress')}
    value={userInput}
    onChange={handleChange}
    onKeyDown={handleEnterPress}
  />
            </div>
          </Autocomplete>
        )}
      </section>
      <div className="Google-map">
        {!isLoaded ? (
           <h1>{t('common:loading')}</h1>
        ) : (
          <div id="captureMap">
            <GoogleMap
              key={bmapKey}
              mapContainerClassName="map-container"
              center={centerRef.current}
              zoom={zoomRef.current}
              mapTypeId="satellite"
              onZoomChanged={handleZoomChange}
              onTiltChanged={handleTiltChange}
              tilt={0}
              clickableIcons={false}
              onDragEnd={handleMapDragEnd}
              onClick={handleMapClick}
              onLoad={(map) => {
                mapRef.current = map;
                map.setZoom(zoomRef.current);

                // Check if we need to fit bounds
                if (sessionStorage.getItem('fitBounds') === 'true') {
                  sessionStorage.removeItem('fitBounds');

                  // Create bounds from all polygons
                  if (TiltedPolygon.length > 0 || verticalPolygon.length > 0) {
                    const bounds = new google.maps.LatLngBounds();

                    // Add tilted polygon points to bounds
                    TiltedPolygon.forEach(poly => {
                      poly.forEach(point => {
                        bounds.extend(new google.maps.LatLng(point.lat, point.lng));
                      });
                    });

                    // Add vertical polygon points to bounds
                    verticalPolygon.forEach(poly => {
                      poly.forEach(point => {
                        bounds.extend(new google.maps.LatLng(point.lat, point.lng));
                      });
                    });

                    // Fit the map to those bounds with some padding
                    map.fitBounds(bounds, 50); // 50 pixels of padding

                    // After the bounds are set, zoom out slightly for better context
                    google.maps.event.addListenerOnce(map, 'bounds_changed', () => {
                      const zoom = map.getZoom();
                      if (zoom && zoom > 20) {
                        map.setZoom(20);
                      }
                    });
                  }
                }
              }}
              options={mapOptions}
            >
              {/* shows the detection points */}
              {detectionPoints.flat().map((coord, markerIndex) => {
  return (
    <React.Fragment key={`detection-marker-${markerIndex}`}>
      {/* Static marker with label (your numbered icon) */}
      <Marker
        position={{ lat: coord.lat, lng: coord.lng }}
        label={{
          text: `${markerIndex + 1}`,
          className: "marker-label",
        }}
        icon={{
          url: images.DetectionPointIcon,
          scaledSize: new window.google.maps.Size(30, 30),
          anchor: new window.google.maps.Point(15, 15),
        }}
        clickable={false}
        zIndex={2}
      />

      {/* Draggable marker with enhanced visibility but similar style */}
      <Marker
        position={{ lat: coord.lat, lng: coord.lng }}
        draggable={true}
        onLoad={handleMarkerLoad}
        onDrag={(e) => {
          if (e.latLng) {
            const newCoords = {
              lat: e.latLng.lat(),
              lng: e.latLng.lng(),
            };
            dispatch(
              addDetectionPoints({
                index: markerIndex,
                detectionPoints: [newCoords],
              })
            );
          }
        }}
        icon={{
          url: "https://img.icons8.com/?size=20&id=BGuoJHQjQ6Qa&format=png&color=000000", // Black version of your icon
  scaledSize: new window.google.maps.Size(20, 20),
  anchor: new window.google.maps.Point(10, 10),
        }}
        zIndex={1}
      />
    </React.Fragment>
  );
})}
              {/* shows the vertical polygons */}
              {verticalPolygon.map((polygonCoords, index) => {
  if (polygonCoords.length < 2) return null;

  const dx = polygonCoords[1].lng - polygonCoords[0].lng;
  const dy = polygonCoords[1].lat - polygonCoords[0].lat;

  const length = 0.000005;

  const perpDx = dy;
  const perpDy = dx;

  const magnitude = Math.sqrt(perpDx * perpDx + perpDy * perpDy);
  const unitPerpDx = (perpDx / magnitude) * length;
  const unitPerpDy = (perpDy / magnitude) * length;
  
  // Calculate center point for the label
  const centerPoint = {
    lat: (polygonCoords[0].lat + polygonCoords[1].lat) / 2,
    lng: (polygonCoords[0].lng + polygonCoords[1].lng) / 2
  };

  return (
    <React.Fragment key={`polygon-${index}`}>
      <Polyline
        key={`polyline-${index}`}
        path={polygonCoords.map(({ lat, lng }) => ({ lat, lng }))}
        options={{
          strokeColor: "#3BCC23",
          strokeOpacity: 1,
          zIndex: 1,
        }}
        onMouseOver={() => setHoveredVerticalIndex(index)}
        onMouseOut={() => setHoveredVerticalIndex(null)}
      />
      
      {/* Add area label for vertical PV */}
      <Marker
        position={centerPoint}
        icon={{
          path: google.maps.SymbolPath.CIRCLE,
          scale: 0, // Invisible marker
          fillOpacity: 0,
          strokeOpacity: 0
        }}
        label={{
          text: `VPV-${index + 1}`,
          className: "area-label",
          color: "#FFFFFF",
          fontWeight: "bold",
          fontSize: "14px"
        }}
        clickable={false}
      />
      
      {/* Green polygon on the left side */}
      <Polygon
        paths={[
          {
            lat: polygonCoords[0].lat,
            lng: polygonCoords[0].lng,
          },
          {
            lat: polygonCoords[1].lat,
            lng: polygonCoords[1].lng,
          },
          {
            lat: polygonCoords[1].lat + unitPerpDy,
            lng: polygonCoords[1].lng - unitPerpDx,
          },
          {
            lat: polygonCoords[0].lat + unitPerpDy,
            lng: polygonCoords[0].lng - unitPerpDx,
          },
        ]}
        options={{
          strokeOpacity: 0,
          strokeWeight: 0,
          fillColor: "#2F3F50",
          fillOpacity: 0.85,
          editable: false,
        }}
        onMouseOver={() => setHoveredVerticalIndex(index)}
        onMouseOut={() => setHoveredVerticalIndex(null)}
      />
      {/* Blue polygon on the right side */}
      <Polygon
        paths={[
          {
            lat: polygonCoords[0].lat,
            lng: polygonCoords[0].lng,
          },
          {
            lat: polygonCoords[1].lat,
            lng: polygonCoords[1].lng,
          },
          {
            lat: polygonCoords[1].lat - unitPerpDy,
            lng: polygonCoords[1].lng + unitPerpDx,
          },
          {
            lat: polygonCoords[0].lat - unitPerpDy,
            lng: polygonCoords[0].lng + unitPerpDx,
          },
        ]}
        options={{
          strokeOpacity: 0,
          strokeWeight: 0,
          fillColor: "#F8AB19",
          fillOpacity: 0.85,
          editable: false,
        }}
        onMouseOver={() => setHoveredVerticalIndex(index)}
        onMouseOut={() => setHoveredVerticalIndex(null)}
      />
      {polygonCoords.map((coord, markerIndex) => {
        return (
          <Marker
            key={`marker-${index}-${markerIndex}`}
            position={coord}
            label={
              hoveredVerticalIndex === index
              ? {
                  text: `${markerIndex + 1}`,
                  className: "marker-label",
                  color: "#FFFFFF",
                  fontWeight: "bold",
                  fontSize: "14px"
                }
              : undefined
            }
            draggable={true}
            onDrag={(e) => {
              if (markerIndex === 0 && e.latLng) {
                const newPolyline = [
                  {
                    lat: e.latLng.lat(),
                    lng: e.latLng.lng(),
                    type: "start",
                  },
                  { ...polygonCoords[1] },
                ];
                dispatch(
                  addVerticalPolygon({
                    index,
                    verticalPolygon: newPolyline,
                  })
                );
              }
              if (markerIndex === 1 && e.latLng) {
                const newPolyline = [
                  { ...polygonCoords[0] },
                  {
                    lat: e.latLng.lat(),
                    lng: e.latLng.lng(),
                    type: "end",
                  },
                ];
                dispatch(
                  addVerticalPolygon({
                    index,
                    verticalPolygon: newPolyline,
                  })
                );
              }
            }}
            onClick={(e) => {
              if (e.latLng && selectedAreaType === "vertical") {
                const newCoords = {
                  lat: e.latLng.lat(),
                  lng: e.latLng.lng(),
                };
                setClickedCoords((prevMarkers) => {
                  return [...prevMarkers, newCoords];
                });
              }
            }}
            icon={{
              url: "https://img.icons8.com/?size=20&id=BGuoJHQjQ6Qa&format=png&color=ffffff",
              scaledSize: new google.maps.Size(20, 20),
              anchor: new google.maps.Point(10, 10),
            }}
            cursor="crosshair"
          />
        );
      })}
    </React.Fragment>
  );
})}
              {/* To show the ruler line on the map */}
              {rulerLine.map((coords, rulerIndex) => {
                const path = [
                  { lat: coords.start.lat, lng: coords.start.lng },
                  { lat: coords.end.lat, lng: coords.end.lng },
                ];
                return (
                  <React.Fragment key={`ruler-line-${rulerIndex}`}>
                    {/* Marker for the start point */}
                    <Marker
                      position={{
                        lat: coords.start.lat,
                        lng: coords.start.lng,
                      }}
                      icon={{
                        url: "https://img.icons8.com/?size=25&id=BGuoJHQjQ6Qa&format=png&color=ffffff",
                        scaledSize: new google.maps.Size(25, 25),
                        anchor: new google.maps.Point(12, 12),
                      }}
                      draggable={true}
                      onDrag={(e) => {
                        const startLat = e.latLng?.lat();
                        const startLng = e.latLng?.lng();
                        const endLat = coords.end.lat;
                        const endLng = coords.end.lng;

                        if (
                          typeof startLat === "number" &&
                          typeof startLng === "number" &&
                          typeof endLat === "number" &&
                          typeof endLng === "number"
                        ) {
                          const newPolyline = [
                            {
                              lat: startLat,
                              lng: startLng,
                              type: "start",
                            },
                            {
                              lat: endLat,
                              lng: endLng,
                              type: "start",
                            },
                          ];
                          dispatch(
                            addRulerLine({
                              index: rulerIndex,
                              rulerLine: newPolyline,
                            })
                          );
                        }
                      }}
                      label={{
                        text:
                          calculateRulerLength(coords).toString() + " " + "m",
                        className: "custom-marker-lable",
                      }}
                    />
                    {/* Marker for the end point */}
                    <Marker
                      position={{ lat: coords.end.lat, lng: coords.end.lng }}
                      icon={{
                        url: "https://img.icons8.com/?size=25&id=BGuoJHQjQ6Qa&format=png&color=ffffff",
                        // scaledSize: new google.maps.Size(25, 25),
                        anchor: new google.maps.Point(12, 12),
                      }}
                      draggable={true}
                      onDrag={(e) => {
                        const startLat = coords.start.lat;
                        const startLng = coords.start.lng;
                        const endLat = e.latLng?.lat();
                        const endLng = e.latLng?.lng();

                        if (
                          typeof startLat === "number" &&
                          typeof startLng === "number" &&
                          typeof endLat === "number" &&
                          typeof endLng === "number"
                        ) {
                          const newPolyline = [
                            {
                              lat: startLat,
                              lng: startLng,
                              type: "start",
                            },
                            {
                              lat: endLat,
                              lng: endLng,
                              type: "start",
                            },
                          ];
                          dispatch(
                            addRulerLine({
                              index: rulerIndex,
                              rulerLine: newPolyline,
                            })
                          );
                        }
                      }}
                    />
                    {/* Polyline */}
                    <Polyline
                      path={path}
                      options={
                        {
                          strokeColor: "#000",
                          strokeOpacity: 0.8,
                          strokeWeight: 2,
                          icons: [
                            {
                              offset: "0",
                              repeat: "20px",
                            },
                          ],
                          lineDashPattern: 170,
                          zIndex: 100,
                        } as any
                      } // Cast options to any type
                    />
                  </React.Fragment>
                );
              })}
              {ClickedRulerPoints.map((coord, markerIndex) => (
                <Marker
                  key={markerIndex}
                  position={coord}
                  icon={{
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 4,
                    fillColor: "#FFF",
                    fillOpacity: 1,
                    strokeColor: "#FFF",
                    strokeOpacity: 1,
                    strokeWeight: 1,
                  }}
                />
              ))}
              {/* To show the vertical tilted point before adding in the verticalpolygons */}
              {clickedCoords.map((coord, markerIndex) => (
                <Marker
                  key={markerIndex}
                  position={coord}
                  icon={{
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 4,
                    fillColor: "#0000FF",
                    fillOpacity: 1,
                    strokeColor: "#0000FF",
                    strokeOpacity: 1,
                    strokeWeight: 1,
                  }}
                />
              ))}
              {/* To show the tilted tilted point before adding in the tiltedPolygons */}
              {clickedTiltedCoords.map((coord, markerIndex) => {
                const coordLength = clickedTiltedCoords.length - 1;
                return (
                  <React.Fragment>
                    <Marker
                      key={markerIndex}
                      position={coord}
                      icon={
                        coordLength === 1
                          ? {
                              url: "https://img.icons8.com/?size=20&id=BGuoJHQjQ6Qa&format=png&color=ffffff",
                              // scaledSize: new google.maps.Size(25, 25),
                              // anchor: new google.maps.Point(12, 12),
                            }
                          : {
                              path: google.maps.SymbolPath.CIRCLE,
                              scale: 4,
                              fillColor: "#FFF",
                              fillOpacity: 1,
                              strokeColor: "#FFF",
                              strokeOpacity: 1,
                              strokeWeight: 1,
                            }
                      }
                      draggable={coordLength === 1 ? true : false}
                      onDrag={(e) => {
                        if (e.latLng) {
                          const newCoords = {
                            lat: e.latLng.lat(),
                            lng: e.latLng.lng(),
                          };
                          setClickedTiltedCoords((prev) => {
                            const coords = [...prev];
                            coords[markerIndex] = newCoords;
                            return coords;
                          });
                        }
                      }}
                      // label={`${markerIndex + 1}`}
                    />
                    <Polyline
                      path={clickedTiltedCoords}
                      options={{
                        strokeColor: "#fff",
                        strokeOpacity: 1,
                        strokeWeight: 2,
                        zIndex: 0,
                      }}
                    />
                  </React.Fragment>
                );
              })}
              {TiltedPolygon.map((poly, polygonIndex) => {
                const greenPath = [poly[0], poly[1]];
                // Correctly calculate the average latitude and longitude
                const averageLat = (poly[0].lat + poly[1].lat) / 2;
                const averageLng = (poly[0].lng + poly[1].lng) / 2;
                return (
                  <React.Fragment key={`fragment-${polygonIndex}`}>
                    <Polyline
                      key={`polyline-green-${polygonIndex}`}
                      path={greenPath}
                      options={{
                        strokeColor: "#00FF00", // Green color
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        zIndex: 100,
                      }}
                      onClick={(e) => {
                        if (
                          e.latLng?.lat() &&
                          e.latLng?.lng() &&
                          selectedAreaType === "ruler"
                        ) {
                          const newCoords = {
                            lat: e.latLng?.lat(),
                            lng: e.latLng?.lng(),
                          };
                          setClickedRulerPoints((prevMarkers) => [
                            ...prevMarkers,
                            newCoords,
                          ]);
                        }
                      }}
                    />
                    {showRotation === polygonIndex && (
                      <Marker
                        position={{ lat: averageLat, lng: averageLng }}
                        draggable={true}
                        onDrag={(e) => {
                          if (e.latLng?.lat() && e.latLng.lng()) {
                            const newLat = e.latLng.lat();
                            const newLng = e.latLng.lng();
                            const deltaLat = newLat - averageLat;
                            const deltaLng = newLng - averageLng;
                            const newCoord = [
                              {
                                lat: poly[0].lat + deltaLat,
                                lng: poly[0].lng + deltaLng,
                              },
                              {
                                lat: poly[1].lat + deltaLat,
                                lng: poly[1].lng + deltaLng,
                              },
                              { lat: poly[2].lat, lng: poly[2].lng },
                              { lat: poly[3].lat, lng: poly[3].lng },
                            ];
                            dispatch(
                              addTiltedPolygon({
                                index: polygonIndex,
                                tiltedPolygon: newCoord,
                              })
                            );
                          }
                        }}
                        icon={{
                          url: "https://img.icons8.com/?size=20&id=BGuoJHQjQ6Qa&format=png&color=ffffff",
                          scaledSize: new google.maps.Size(20, 20),
                          anchor: new google.maps.Point(10, 10),
                        }}
                      />
                    )}
                  </React.Fragment>
                );
              })}

              {/* Render red polyline for points 3 and 4 */}
              {TiltedPolygon.map((poly, polygonIndex) => {
                const redPath = [poly[2], poly[3]]; // Points 3 and 4
                const averageLat = (poly[2].lat + poly[3].lat) / 2;
                const averageLng = (poly[2].lng + poly[3].lng) / 2;

                return (
                  <React.Fragment>
                    <Polyline
                      key={`polyline-red-${polygonIndex}`}
                      path={redPath}
                      options={{
                        strokeColor: "#FF0000", // Red color
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        zIndex: 100,
                      }}
                      onClick={(e) => {
                        if (
                          e.latLng?.lat() &&
                          e.latLng?.lng() &&
                          selectedAreaType === "ruler"
                        ) {
                          const newCoords = {
                            lat: e.latLng?.lat(),
                            lng: e.latLng?.lng(),
                          };
                          setClickedRulerPoints((prevMarkers) => [
                            ...prevMarkers,
                            newCoords,
                          ]);
                        }
                      }}
                    />
                    {showRotation === polygonIndex && (
                      <Marker
                        position={{ lat: averageLat, lng: averageLng }}
                        draggable={true}
                        onDrag={(e) => {
                          if (e.latLng?.lat() && e.latLng.lng()) {
                            const newLat = e.latLng.lat();
                            const newLng = e.latLng.lng();
                            const deltaLat = newLat - averageLat;
                            const deltaLng = newLng - averageLng;

                            const newCoord = [
                              { lat: poly[0].lat, lng: poly[0].lng },
                              { lat: poly[1].lat, lng: poly[1].lng },
                              {
                                lat: poly[2].lat + deltaLat,
                                lng: poly[2].lng + deltaLng,
                              },
                              {
                                lat: poly[3].lat + deltaLat,
                                lng: poly[3].lng + deltaLng,
                              },
                            ];

                            dispatch(
                              addTiltedPolygon({
                                index: polygonIndex,
                                tiltedPolygon: newCoord,
                              })
                            );
                          }
                        }}
                        icon={{
                          url: "https://img.icons8.com/?size=20&id=BGuoJHQjQ6Qa&format=png&color=ffffff",
                          scaledSize: new google.maps.Size(20, 20),
                          anchor: new google.maps.Point(10, 10),
                        }}
                      />
                    )}
                  </React.Fragment>
                );
              })}

{TiltedPolygon.map((poly, polygonIndex) => {
  const isTilted = checkIfLinesIntersect(poly);
  const strokeColor = !isTilted ? "#000000" : "#FF0000";
  const fillColor = !isTilted ? "#000000" : "#FF0000";
  const centroid = calculateCentroid(poly);

  return (
    <React.Fragment key={`polygon-${polygonIndex}`}>
      <Polygon
        onMouseOver={() => {
          setShowRotation(polygonIndex);
          setHoveredPolygonIndex(polygonIndex);
        }}
        onMouseOut={() => {
          setShowRotation(null);
          setHoveredPolygonIndex(null);
        }}
        onClick={(e) => {
          if (
            e.latLng?.lat() &&
            e.latLng?.lng() &&
            selectedAreaType === "exclude"
          ) {
            const newCoords = {
              lat: e.latLng?.lat(),
              lng: e.latLng?.lng(),
            };
            handleExcludeArea(newCoords);
          }
          if (
            e.latLng?.lat() &&
            e.latLng?.lng() &&
            selectedAreaType === "ruler"
          ) {
            const newCoords = {
              lat: e.latLng?.lat(),
              lng: e.latLng?.lng(),
            };
            setClickedRulerPoints((prevMarkers) => [
              ...prevMarkers,
              newCoords,
            ]);
          }
        }}
        paths={poly.map((coord) => ({
          lat: coord.lat,
          lng: coord.lng,
        }))}
        options={{
          strokeColor: strokeColor,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: fillColor,
          fillOpacity: 0.35,
        }}
      />
      
      {/* Add area label in the center of each tilted polygon */}
      <Marker
        position={centroid}
        icon={{
          path: google.maps.SymbolPath.CIRCLE,
          scale: 0, // Invisible marker
          fillOpacity: 0,
          strokeOpacity: 0
        }}
        label={{
          text: `TPV-${polygonIndex + 1}`,
          className: "area-label",
          color: "#FFFFFF",
          fontWeight: "bold",
          fontSize: "14px"
        }}
        clickable={false}
      />
      
      {showRotation === polygonIndex && (
        <Marker
          onMouseDown={(e) => {
            e.domEvent.stopPropagation();
            handleMouseDown(e.domEvent, polygonIndex);
          }}
          position={centroid}
          icon={{
            url: "https://img.icons8.com/material-outlined/24/ffffff/rotate-right.png",
            scaledSize: new google.maps.Size(25, 25),
            anchor: new google.maps.Point(12, 12),
          }}
          cursor={"pointer"}
        />
      )}
      
      {poly.map((coord, markerIndex) => (
        <React.Fragment key={`marker-fragment-${polygonIndex}-${markerIndex}`}>
          <Marker
            onMouseOver={() => setShowRotation(polygonIndex)}
            onMouseOut={() => setShowRotation(null)}
            key={`${polygonIndex}-${markerIndex}`}
            position={coord}
            draggable={showRotation === polygonIndex}
            onDrag={(e) => {
              dispatch(
                setTiltedPVIntersection({
                  value: intersectionRef.current,
                })
              );
              if (e.latLng) {
                const newCoords = {
                  lat: e.latLng.lat(),
                  lng: e.latLng.lng(),
                };
                const adjustedCoords =
                  markerIndex <= 1
                    ? calculateAdjustedCoords(
                        newCoords.lat,
                        newCoords.lng,
                        polygonIndex,
                        0,
                        1
                      )
                    : calculateAdjustedCoords(
                        newCoords.lat,
                        newCoords.lng,
                        polygonIndex,
                        2,
                        3
                      );

                dispatch(
                  updateTiltedPolygon({
                    polygonIndex,
                    markerIndex,
                    newCoords: adjustedCoords,
                  })
                );
              }
            }}
            onDragEnd={(e) => {
              if (e.latLng) {
                const newCoords = {
                  lat: e.latLng.lat(),
                  lng: e.latLng.lng(),
                };
                const adjustedCoords =
                  markerIndex <= 1
                    ? calculateAdjustedCoords(
                        newCoords.lat,
                        newCoords.lng,
                        polygonIndex,
                        0,
                        1
                      )
                    : calculateAdjustedCoords(
                        newCoords.lat,
                        newCoords.lng,
                        polygonIndex,
                        2,
                        3
                      );

                dispatch(
                  updateTiltedPolygon({
                    polygonIndex,
                    markerIndex,
                    newCoords: adjustedCoords,
                  })
                );
              }
            }}
            icon={
              showRotation === polygonIndex
                ? {
                    url: "https://img.icons8.com/?size=24&id=98061&format=png&color=ffffff",
                    scaledSize: new google.maps.Size(25, 25),
                    anchor: new google.maps.Point(12, 12),
                  }
                : {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 4,
                    fillColor: "#FFF",
                    fillOpacity: 1,
                    strokeColor: "#FFF",
                    strokeOpacity: 1,
                    strokeWeight: 1,
                  }
            }
            cursor="crosshair"
            label={
              // Only show the label when hovering over the polygon or specific marker
              (hoveredPolygonIndex === polygonIndex || showRotation === polygonIndex)
              ? {
                  text: `${markerIndex + 1}`, 
                  className: "marker-label",
                  color: "#FFFFFF",
                  fontWeight: "bold", 
                  fontSize: "14px"
                } 
              : undefined
            }
          />
        </React.Fragment>
      ))}
    </React.Fragment>
  );
})}

{excludeArea.map((excludeCoord: any[], index: number) => {
  const centroid = calculateCentroidofExclude(excludeCoord);
  // Check if this is a completed polygon (first and last points match)
  const isCompletedPolygon = 
    excludeCoord.length > 2 && 
    excludeCoord[0]?.lat === excludeCoord[excludeCoord?.length - 1]?.lat &&
    excludeCoord[0]?.lng === excludeCoord[excludeCoord?.length - 1]?.lng;
  
  return (
    <React.Fragment key={`exclude-area-${index}`}>
      {isCompletedPolygon ? (
        <React.Fragment>
          {/* Completed polygon with fill */}
          <Polygon
            path={excludeCoord.map((coord) => ({
              lat: coord.lat,
              lng: coord.lng,
            }))}
            options={{
              strokeColor: "#2D0A92",
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: "#F8AB19",
              fillOpacity: 0.35,
              zIndex: 1000,
            }}
            onMouseOver={() => setHoveredExcludeIndex(index)}
            onMouseOut={() => setHoveredExcludeIndex(null)}
          />
          
          {/* Control points for the polygon */}
          {excludeCoord.map((coords, coordIndex) => {
            // Skip the last point since it's the same as the first in a closed polygon
            if (coordIndex === excludeCoord.length - 1) return null;
            
            // Only show markers when hovering over the polygon or when one is being dragged
            const shouldShowMarker = hoveredExcludeIndex === index;
            
            return (
              <Marker
                key={`exclude-marker-${index}-${coordIndex}`}
                position={{ lat: coords.lat, lng: coords.lng }}
                draggable={true}
                visible={shouldShowMarker}
                onMouseOver={() => setHoveredExcludeIndex(index)}
                onDrag={(e) => {
                  if (e.latLng?.lat() && e.latLng?.lng()) {
                    const newCoords = {
                      lat: e.latLng?.lat(),
                      lng: e.latLng?.lng(),
                    };
                    setCoordinatesArray((prev) => {
                      const newCoord = [...prev];
                      if (coordIndex === 0) {
                        // If we're moving the first point, also update the last point to keep the polygon closed
                        newCoord[index][0] = newCoords;
                        newCoord[index][excludeCoord.length - 1] = newCoords;
                      } else {
                        newCoord[index][coordIndex] = newCoords;
                      }
                      return newCoord;
                    });
                  }
                }}
                icon={{
                  url: "https://img.icons8.com/?size=24&id=98061&format=png&color=ffffff",
                  scaledSize: new google.maps.Size(25, 25),
                  anchor: new google.maps.Point(12, 12),
                }}
                cursor="move"
                zIndex={2000}
              />
            );
          })}
          
          {/* Center control point for moving the entire polygon */}
          <Marker
            draggable={true}
            position={centroid}
            visible={hoveredExcludeIndex === index}
            onMouseOver={() => setHoveredExcludeIndex(index)}
            cursor="move"
            onDrag={(e) => {
              if (e.latLng?.lat() && e.latLng?.lng()) {
                const newLat = e.latLng.lat();
                const newLng = e.latLng.lng();
                const deltaLat = newLat - centroid.lat;
                const deltaLng = newLng - centroid.lng;

                setCoordinatesArray((prev) => {
                  const newCoord = [...prev];
                  newCoord[index] = excludeCoord.map((coord) => ({
                    lat: coord.lat + deltaLat,
                    lng: coord.lng + deltaLng,
                  }));
                  return newCoord;
                });
              }
            }}
            icon={{
              url: "https://img.icons8.com/material-outlined/24/ffffff/move.png",
              scaledSize: new google.maps.Size(25, 25),
              anchor: new google.maps.Point(12, 12),
            }}
            zIndex={2001} // Ensure move icon is above corner markers
          />
        </React.Fragment>
      ) : (
        // Incomplete polygon (in-progress drawing)
        <React.Fragment>
          <Polyline
            path={excludeCoord.map((coord) => ({
              lat: coord.lat,
              lng: coord.lng,
            }))}
            options={{
              strokeColor: "#FF6B00",
              strokeOpacity: 1,
              strokeWeight: 2,
              zIndex: 10000,
            }}
          />
          {excludeCoord.map((coords, coordIndex) => {
            return (
              <Marker
                key={`exclude-in-progress-${index}-${coordIndex}`}
                position={{ lat: coords.lat, lng: coords.lng }}
                onClick={(e) => {
                  if (e.latLng?.lat() && e.latLng?.lng()) {
                    // If clicking on the first point and we have at least 3 points,
                    // complete the polygon by closing it
                    if (coordIndex === 0 && excludeCoord.length >= 3) {
                      const newCoords = {
                        lat: excludeCoord[0].lat,
                        lng: excludeCoord[0].lng,
                      };
                      handleExcludeArea(newCoords);
                    } else {
                      const newCoords = {
                        lat: e.latLng?.lat(),
                        lng: e.latLng?.lng(),
                      };
                      handleExcludeArea(newCoords);
                    }
                  }
                }}
                cursor={coordIndex === 0 && excludeCoord.length >= 3 ? "pointer" : "crosshair"}
                icon={{
                  path: google.maps.SymbolPath.CIRCLE,
                  scale: coordIndex === 0 ? 5 : 3,
                  fillColor: coordIndex === 0 ? "#FF6B00" : "#fff",
                  fillOpacity: 1,
                  strokeColor: "#fff",
                  strokeOpacity: 1,
                  strokeWeight: 1,
                }}
                label={coordIndex === 0 && excludeCoord.length >= 3 ? {
                  text: "Close",
                  className: "exclude-close-label",
                  color: "#FFFFFF",
                  fontSize: "10px"
                } : undefined}
                clickable={true}
              />
            );
          })}
        </React.Fragment>
      )}
    </React.Fragment>
  );
})}
            </GoogleMap>
          </div>
        )}
      </div>
    </div>
  );
};

export default MapPageRender;